import { SponsorshipLevel } from './SponsorshipLevel.js';

// Subscription represents a subscription.
export class Subscription {
    constructor(data) {
        let nextLevel = null;
        if (data.next_level) {
            nextLevel = new SponsorshipLevel(data.next_level);
        }
        this.level = new SponsorshipLevel(data.level);
        this.nextLevel = nextLevel;
        this.paidTill = data.paid_till;
        this.nextRecurrentPayment = data.next_recurrent_payment;
        this.lastPayment = data.last_payment;
        this.lastFailedPaymentAttempt = data.last_failed_payment_attempt;
        this.recurrent = data.recurrent;
        this.inPayment = data.in_payment;
        this.paymentMethodStatus = data.payment_method_status;
        this.status = data.status;
        this.lifecycleStatus = data.lifecycle_status || null;
        this.isGifted = !!data.is_gifted;
    }
}
